import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    addOffSiteData: "",
    getOffSiteData: [],
    completedArray: [],
    inProgressArray: [],
    pendingArray: []

}

const OffSiteReducer = (state = initState, { type, payload }) => {

    switch (type) {

        case CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.ADD_OFFSITE_API_SUCCESS:
            return {
                ...state,
                addOffSiteData: payload.value
            }

        case CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.GET_OFFSITE_API_SUCCESS:

            return {
                ...state,
                getOffSiteData: payload.value
            }


        case CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.OFFSITE_COMPLETED_ARRAY:

            return {
                ...state,
                completedArray: payload.value
            }


        case CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.OFFSITE_IN_PROGRESS_ARRAY:

            return {
                ...state,
                inProgressArray: payload.value
            }


        case CONSTANTS.CONSTANTS_OFFSITE_MANAGEMENT.OFFSITE_PENINDING_ARRAY:

            return {
                ...state,
                pendingArray: payload.value
            }

        default:
            return state
    }
}

export default OffSiteReducer;
